import './TableMatches.css'
import React, { useState, useEffect, memo } from 'react'
import { useTranslation } from 'react-i18next'

const TableMatchesComponent = (props) => {
	const { t } = useTranslation()
	// Получаем объединенный массив для таблицы Матчи
	const [tableMatches, setTableMatches] = useState([])

	const openMatch = (match) => {
		console.log(match)

		if (!props?.auth || match?.noMatch) {
			return
		}

		const updatedMatch = { ...match, uid: match?.matchUid }
		props?.sendMatchData(updatedMatch)
		sessionStorage.setItem('activatedComponent', 'match')
		sessionStorage.setItem('match', JSON.stringify(updatedMatch))
	}

	// updatedMatch для таблицы Матчи
	useEffect(() => {
		if (Object.keys(props.data).length !== 0) {
			const tableMatchesArray = props?.data?.levels?.map((level, levelIndex) => {
				return level?.groups?.map((group, groupIndex) => {
					const matchesArray = group?.matches?.map(match => {
						if (props.tournamentState.doubles === null) {
							const nodeName = group.nodes.find((node, index, array) => {
								return node.double_uid === null &&
									node.player_uid === null &&
										node.type === 'incoming' &&
											node.type === 'middle'
							})

							if (nodeName) {
								// Одиночный (если пока нет игроков)
								const nodeMatchSide1 = group.nodes.find((node, index, array) => {
									return node.uid === match.side1_uid
								})

								const nodeMatchSide2 = group.nodes.find((node, index, array) => {
									return node.uid === match.side2_uid
								})

								return {
									side1: {
										namePlayer: nodeMatchSide1 ? nodeMatchSide1?.name : '---'
									},
									side2: {
										namePlayer: nodeMatchSide2 ? nodeMatchSide2?.name : '---'
									},
									sets: [],
									doubleBoll: false,
									matchUid: match?.uid,
									name: group?.name,
									levelIndex: levelIndex,
									groupIndex: groupIndex,
									noMatch: !nodeMatchSide1 || !nodeMatchSide2 ? true : false
								}

							} else {
								// Одиночный (если есть игроки)
								const playerSide1 = group.nodes.find((item, index, array) => {
									return match.side1_uid === item.uid
								})
								const matchSide1 = props.tournamentState.players.find((item, index, array) => {
									return playerSide1.player_uid === item.uid
								})

								const playerSide2 = group.nodes.find((item, index, array) => {
									return match.side2_uid === item.uid
								})
								const matchSide2 = props.tournamentState.players.find((item, index, array) => {
									return playerSide2.player_uid === item.uid
								})

								return {
									side1: {
										namePlayer: matchSide1 ? matchSide1?.formedName : '---'
									},
									side2: {
										namePlayer: matchSide2 ? matchSide2?.formedName : '---'
									},
									name: group?.name,
									sets: match?.sets,
									doubleBoll: false,
									matchUid: match?.uid,
									levelIndex: levelIndex,
									groupIndex: groupIndex,
									noMatch: !matchSide1 || !matchSide2 ? true : false
								}
							}
						} else {
							const nodeName = group.nodes.find((node) => {
								return node.double_uid === null &&
									node.player_uid === null &&
										node.type === 'incoming' &&
											node.type === 'middle'
							})

							if (nodeName) {
								// Парный (если пока нет игроков)
								const nodeMatchSide1 = group.nodes.find((node) => {
									return node.uid === match.side1_uid
								})

								const nodeMatchSide2 = group.nodes.find((node) => {
									return node.uid === match.side2_uid
								})

								return {
									side1: {
										namePlayer1: nodeMatchSide1 ? nodeMatchSide1?.name : '---'
									},
									side2: {
										namePlayer2: nodeMatchSide1 ? nodeMatchSide2?.name : '---'
									},
									sets: [],
									doubleBoll: true,
									matchUid: match?.uid,
									name: group?.name,
									levelIndex: levelIndex,
									groupIndex: groupIndex,
									noMatch: nodeMatchSide1 || nodeMatchSide2 ? true : false
								}
							}
							else {
								// Парный (если есть игроки)
								const playerSide1 = group.nodes.find((item, index, array) => {
									return match.side1_uid === item.uid
								})
								const matchSide1 = props.tournamentState.doubles.find((item, index, array) => {
									return playerSide1.double_uid === item.uid
								})

								const playerSide2 = group.nodes.find((item, index, array) => {
									return match.side2_uid === item.uid
								})
								const matchSide2 = props.tournamentState.doubles.find((item, index, array) => {
									return playerSide2.double_uid === item.uid
								})

								return {
									side1: {
										namePlayer1: matchSide1 ? matchSide1.player1.formedName : '---',
										namePlayer2: matchSide1 ? matchSide1.player2.formedName : '---'
									},
									side2: {
										namePlayer1: matchSide2 ? matchSide2.player1.formedName : '---',
										namePlayer2: matchSide2 ? matchSide2.player2.formedName : '---'
									},
									sets: match?.sets,
									doubleBoll: true,
									matchUid: match?.uid,
									name: group?.name,
									levelIndex: levelIndex,
									groupIndex: groupIndex,
									noMatch: playerSide2?.double_uid && playerSide1?.double_uid ? false : true
								}
							}
						}
					})

					return { matches: matchesArray }
				})
			}).flat(2)

			setTableMatches(tableMatchesArray)
		} else {
			return
		}
	}, [props.data, props.tournamentState])

	return (
		<>
			{
				tableMatches?.map((tableMatch, tableMatchIndex) => {
					if (tableMatch?.matches.length > 0) {
						return <React.Fragment key={tableMatchIndex}>
							<div className="match-group__container">
								<p className="match-group__title">
									{t('Group')} {tableMatch?.matches[0]?.name}
								</p>
							</div>

							<div className="match-table__container">
								{
									tableMatch.matches.map((match, matchesIndex) => {
										return <div className="match-table__body" key={matchesIndex}>

											<div className="match-table__content">
												{ matchesIndex + 1 }
											</div>

											<div className="match-table__content">
												{
													match.doubleBoll === false ?
														// Одиночный
														<>
															<p>{`${match.side1.namePlayer}`}</p>
															<p>{`${match.side2.namePlayer}`}</p>
														</>
														:
														// Парный
														!match.side2.namePlayer1 && !match?.side1?.namePlayer2 ?
															<>
																<p>{`${match.side1.namePlayer1}`}</p>
																<p>{`${match?.side2?.namePlayer2}`}</p>
															</>
															:
															<>
																<p>
																	{`${match.side1.namePlayer1}`}
																	<br />
																	{`${match?.side1?.namePlayer2}`}
																</p>
																<p>
																	{`${match.side2.namePlayer1}`}
																	<br />
																	{`${match?.side2?.namePlayer2}`}
																</p>
															</>
												}
											</div>

											<div className="match-table__content">
												<div>
													{
														match?.sets?.length !== 0 ? (
															match?.sets?.map((tableMatchSets, tableMatchSetsIndex) => {
																return (
																	<p
																		key={tableMatchSetsIndex}
																		onClick={() => openMatch(match)}
																	>
																		<span>
																			{ tableMatchSets.score1 } {
																				tableMatchSets.tie_break_score1 ? 
																					<sup>
																						{ tableMatchSets.tie_break_score1 }
																					</sup> 
																					:
																					''
																			}
																		</span>
																	</p>
																)
															})
														)
															:
															(
																match.side1.namePlayer !== '---' ?
																	<p onClick={() => openMatch(match)}>
																		<span>
																			0
																		</span>
																	</p>
																	:
																	<p>
																		<span>
																			-
																		</span>
																	</p>
															)
													}
												</div>

												<div>
													{
														match?.sets?.length !== 0 ? (
															match.sets?.map((tableMatchSets, tableMatchSetsIndex) => {
																return ( 
																	<p
																		key={tableMatchSetsIndex}
																		onClick={() => openMatch(match)}
																	>
																		<span>
																			{tableMatchSets.score2} {
																				tableMatchSets.tie_break_score2 ?
																					<sup>
																						{ tableMatchSets.tie_break_score2 }
																					</sup>
																					:
																					''
																			}
																		</span>
																	</p>
																)
															})
														)
															:
															(
																match.side2.namePlayer !== '---' ?
																	<p onClick={() => openMatch(match)}>
																		<span>
																			0
																		</span>
																	</p>
																	:
																	<p>
																		<span>
																			-
																		</span>
																	</p>
															)
													}
												</div>
											</div>
										</div>
									})
								}
							</div>
						</React.Fragment>
					}
					else {
						return null
					}
				})
			}
		</>
	)
}

export const TableMatches = memo(TableMatchesComponent)